"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fov_1 = require("../../../fov");
exports.eventStreamClickCondition = {
    id: 'event-stream-click-condition',
    category: 'behaviors',
    value: {
        pageTypes: [
            {
                value: fov_1.FovPageType.ANY,
                label: 'CONDITION_SELECT_ANY_PAGE',
            },
            {
                value: fov_1.FovPageType.PAGE,
                label: 'CONDITION_SELECT_SPECIFIC_PAGE',
            },
            {
                value: fov_1.FovPageType.URL,
                label: 'CONDITION_SELECT_SPECIFIC_URL',
            },
        ],
    },
};
//# sourceMappingURL=event-stream-click-condition.value.js.map